module.exports = __webpack_public_path__ + "static/media/b58w37.de41761c.jpg";